import React, { useState, useMemo, useCallback } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Spinner,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import MainLayout from "../layouts/MainLayout";
import mailIcon from "../images/pdf/file-send.svg";
import { EditorDocumentPreview } from "../components/DocumentPreview";
import {
  EditorProvider,
  useEditorState,
  useEditor,
  useEditorActions,
} from "../context/editor";
import { useAuthState } from "../context/auth";
import { useProfile } from "../api/hooks/profile";
import EditTemplateConfiguration from "../components/EditTemplateConfiguration";
import useQueryParams from "../hooks/useQuery";
import LoadingButton from "../components/LoadingButton";
import NewEditor from "../components/NewEditor/NewEditor";
function EditTemplate() {
  const { t } = useTranslation("common");
  const [hasSucceed, setHasSucceed] = useState(false);
  const auth = useAuthState();
  const history = useHistory();
  const { can } = useProfile();

  const query = useQueryParams();

  const [editorState, editorDispatch] = useEditor();
  const { checkMissingSignatures } = useEditorActions();

  const { documentId, status } = useEditorState();
  const initialStep = useMemo(() => {
    if (query.get("stepper") === "true" && editorState.isEditable) return 1;
    // if (editorState.isTemplate) return 2
    // if (editorState.isPdf && (query.get('stepper') === "false" || !query.has('stepper'))) return 2;
    return 2;
  }, [editorState.isPdf, query]); //editorState.isTemplate,

  const [currentStep, setCurrentStep] = useState(initialStep);
  const handleGoBack = () => {
    if (query.get("stepper") === "true") {
      setCurrentStep(1);
    } else {
      history.goBack();
    }
  };
  const nextStep = useCallback(() => {
    setCurrentStep((step) => step + 1);
  }, []);

  const handleContinue = () => {
    const isMissingSignatures = checkMissingSignatures();
    if (isMissingSignatures) return;
    nextStep();
  };

  const handleContractSent = useCallback(() => {
    nextStep();
  }, [nextStep]);

  return (
    <MainLayout
      className="p-0"
      footer={false}
      banner={
        !auth?.accessToken && {
          message: t("actions.newTemplates"),
          icon: "file",
        }
      }
      showUpgradeBanner={false}
    >
      <>
        {documentId && status === "success" && !hasSucceed && (
          <Container fluid className={clsx("d-flex p-0 overflow-hidden h-100")}>
            <Row noGutters className="p-0 w-100 h-100 max-h-with-navbar">
              <Col lg={8} className="p-4 h-100 overflow-auto">
                <EditorDocumentPreview card header={true} />
              </Col>
              <Col lg={4} className="h-100">
                <EditTemplateConfiguration
                  className="max-h-with-navbar"
                  tabs={true}
                  currentTab={currentStep}
                  header={false}
                  isEditable={true}
                  templateId={documentId}
                  currentTab={3}
                  footer
                  onReturn={handleGoBack}
                  onContractSent={handleContractSent}
                  FooterComponent={({
                    saving,
                    onGoBack,
                    isSending,
                    onSubmit,
                    isEditable,
                  }) => (
                    <Row className="justify-content-center">
                      {currentStep === 2 && (
                        <Col sm={6}>
                          <LoadingButton
                            color="default"
                            loading={saving}
                            loadingText={t("actions.saving")}
                            className="align-self-end animate-up w-100"
                            onClick={handleGoBack}
                          >
                            {t("actions.goBack")}{" "}
                            {/*<FontAwesomeIcon icon="eye" className="ml-2" /> */}
                          </LoadingButton>
                        </Col>
                      )}
                      <Col
                        sm={currentStep === 1 ? 12 : 6}
                        className="text-center"
                      >
                        {currentStep === 1 ? (
                          <Button
                            size="lg"
                            color="accent-100"
                            onClick={handleContinue}
                          >
                            {t("actions.continue")}
                          </Button>
                        ) : (
                          <LoadingButton
                            color="accent-100"
                            disabled={false}
                            loading={isSending}
                            loadingText={t("actions.sending")}
                            className="align-self-end text-light animate-up w-100 mt-xs-4"
                            onClick={onSubmit}
                          >
                            {t("actions.send")}
                          </LoadingButton>
                        )}
                      </Col>
                    </Row>
                  )}
                />
              </Col>
            </Row>
          </Container>
        )}
      </>
    </MainLayout>
  );
}

function EditTemplateContainer() {
  const { publicTemplateId, templateId } = useParams();

  return (
    <EditorProvider
      documentId={publicTemplateId || templateId}
      mode={publicTemplateId ? "public-template" : "template"}
    >
      <NewEditor />
      {/* <EditTemplate /> */}
    </EditorProvider>
  );
}

export default EditTemplateContainer;
